// src/utils/voyagePlanLogJoin.js
//
// Pass 2c — join from log/plan-card entries back to the canonical plan item
// label. Used by:
//   - LogEntry.js (position + operation_complete header rename)
//   - (future) Pass 3: section header rename (needs backend change first),
//                      inline note, event item type
//
// Pure function. ID-based lookup against voyage.voyagePlanSnapshot.items.
// NEVER reads voyage_settings.voyagePlans (live library) — preserves P4.6
// snapshot semantics.
//
// Returns string | null. NEVER returns 0, "", or undefined — render-zero
// safety per POB hotfix cc4932a. Callers MUST use ternary, not bare `&&`.

/**
 * Resolve a plan item label by item id.
 *
 * @param {Object} voyage   Voyage record. May be null / undefined / pre-Snapshot.
 * @param {String} planItemId   Foreign key from a log entry. May be null / undefined.
 * @returns {String|null}   Label or null. Never 0/empty-string/undefined.
 */
export function findLabelByPlanItemId(voyage, planItemId) {
  if (typeof planItemId !== 'string' || planItemId.length === 0) return null;
  const items = voyage?.voyagePlanSnapshot?.items;
  if (!Array.isArray(items) || items.length === 0) return null;
  const item = items.find(i => i?.id === planItemId);
  if (!item) return null;
  if (item.kind === 'waypoint' && typeof item.label === 'string' && item.label.length > 0) {
    return item.label;
  }
  if (item.kind === 'operation_ref') {
    if (typeof item.displayLabel === 'string' && item.displayLabel.length > 0) {
      return item.displayLabel;
    }
    const snapshotName = item.operationSnapshot?.name;
    if (typeof snapshotName === 'string' && snapshotName.length > 0) {
      return snapshotName;
    }
  }
  return null;
}
